












import { Vue, Component, Prop } from 'vue-property-decorator'
import ItemDataLive from 'src/assets/ItemDataLive'
import InfoEditor from 'components/presenter/item/topic/editor/InfoEditor.vue'
import SlidesEditor from 'components/presenter/item/topic/editor/SlidesEditor.vue'
import { Item } from 'src/graphql/types'

@Component({
  components: {
    InfoEditor,
    SlidesEditor
  }
})
export default class ItemTopicContent extends Vue {
  topicData: ItemDataLive | null = null

  @Prop()
  readonly item!: Item

  get itemWithData () {
    return Object.assign({}, this.item, { data: this.topicData || {} })
  }

  created () {
    this.topicData = new ItemDataLive(this.item.id)
  }

  beforeDestroy () {
    this.topicData?.destroy()
  }

  async refresh (done: () => void) {
    done()
  }

  async load (index: number, done: (stop?: boolean) => void) {
    done(true)
  }
}
